import { PlanLimitConfigs, BillingCycleConfig } from '../types.ts';

export const STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE = 'ANNUAL';
export const STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT = 50;

export const STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT = 50;

export const strategyCollectionOfferingSkus = {
	enterprise: 'strategy-collection-enterprise-sku',
} as const;

export const strategyCollectionOfferingSkusArray = Object.values(strategyCollectionOfferingSkus);

export const strategyCollectionPlanLimitConfigs: PlanLimitConfigs[] = [
	{
		planName: 'Enterprise',
		offeringSku: strategyCollectionOfferingSkus.enterprise,
		recommendationLimit: 2000,
		signupLimit: 2000,
		minUnitCount: STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
	},
];

export const strategyCollectionBillingCycleConfig: BillingCycleConfig = {
	monthly: false,
	annual: true,
};
